import { http } from "@/config/httpCommon"

export default {
    state: {
        currencies: [],
    },
    mutations: {
        set (state, [variable, value]) {
            state[variable] = value
        },
    },
    getters:{
        getCurrency(state){
            return state.currencies;
        },
    },
    actions: {
        async getCurrencies({commit}){
            let res = await http.get(`currency`);
            commit('set', ['currencies', res.data]);
            return res;
        },
    }
} 